import React, { useEffect, useRef, useState } from "react";

const ContadorAnimado = ({ numero }) => {
  const [contador, setContador] = useState(0);
  const [finalizado, setFinalizado] = useState(false);

  const referencia = useRef(null);

  useEffect(() => {
    const elemento = referencia.current;

    if (!elemento) return;

    const observador = new IntersectionObserver(
      ([entrada]) => {

        // Cuando la sección entra en pantalla
        if (entrada.isIntersecting) {

          // Reiniciar contador
          setContador(0);
          setFinalizado(false);

          let inicio = 0;
          const duracion = 1800;
          const incremento = numero / (duracion / 30);

          const intervalo = setInterval(() => {

            inicio += incremento;

            if (inicio >= numero) {

              inicio = numero;

              clearInterval(intervalo);

              // Activar zoom y brillo
              setFinalizado(true);
            }

            setContador(Math.floor(inicio));

          }, 30);

          // Guardamos el intervalo para poder limpiarlo
          elemento.intervaloContador = intervalo;
        } 
        
        // Cuando sale de pantalla
        else {

          // Detener contador
          if (elemento.intervaloContador) {
            clearInterval(elemento.intervaloContador);
          }

          // Reiniciar
          setContador(0);
          setFinalizado(false);
        }
      },
      {
        threshold: 0.5,
      }
    );

    observador.observe(elemento);

    return () => {

      observador.disconnect();

      if (elemento.intervaloContador) {
        clearInterval(elemento.intervaloContador);
      }

    };

  }, [numero]);

  return (
    <h1
      ref={referencia}
      className={`numero-impacto ${
        finalizado ? "numero-finalizado" : ""
      }`}
    >
      {contador}
    </h1>
  );
};

export default ContadorAnimado;